import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import DynamicForm from "../../../../../data/Axios/DynamicForm";
import {
  executeAnyMutation,
  fetchJsonDynamic,
} from "../../../../../data/DynamicServiceNew/jsondynamicservice";
import { customerservice } from "../../../../../config";

const base_url = customerservice.uri;

const GroupMembersForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const groupId = parseInt(localStorage.getItem("GroupId"));
  const userId = parseInt(decodedToken.Id);
  const [customersData, setCustomersData] = useState([]);
  const [groupRolesData, setGroupRolesData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAllData() {
      try {
        const parameters = { groupId };

        // Fetch customers already in the group
        const customerByGroup = await fetchJsonDynamic(
          "customerGroupViewByColumnValues",
          "customerGroupView",
          parameters,
          base_url
        );
        const existingGroupCustomers = JSON.parse(customerByGroup?.results) || [];
        const existingCustomerIds = existingGroupCustomers.map((customer) => customer.CustomerId);

        // Fetch all customers
        const customersResponse = await fetchJsonDynamic(
          "ungrouppedCustomersView", 
          null, 
          null, 
          base_url
        );
        if (customersResponse?.results) {
          const allCustomers = JSON.parse(customersResponse?.results) || [];
          const approvedCustomers = allCustomers.filter((customer) => customer.IsApproved === 2 && customer.LoanLimit > 1);

          // If in edit mode, include existing customers in the options
          if (props.data) {
            const existingCustomers = approvedCustomers.filter((customer) =>
              existingCustomerIds.includes(customer.Id)
            );
            setCustomersData(existingCustomers);
          } else {
            // If not in edit mode, filter out existing customers
            const filteredCustomers = allCustomers.filter(
              (customer) => !existingCustomerIds.includes(customer.Id)
            );
            setCustomersData(filteredCustomers);
            console.log("customers data",approvedCustomers)

          }
        }

        // Fetch group roles
        const groupRolesResponse = await fetchJsonDynamic(
          "groupRolesByColumnValues",
          "groupRole",
          parameters,
          base_url
        );
        if (groupRolesResponse?.results) {
          const roles = JSON.parse(groupRolesResponse?.results) || [];
          setGroupRolesData(roles);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, [groupId, props.data]); // Add props.data as a dependency

  const customersOptions = customersData.map((customer) => ({
    value: customer.Id,
    label: `${customer.FirstName} ${customer.OtherNames} - ${customer.MobileNumber}`,
  }));

  const roleOptions = groupRolesData.map((role) => ({
    value: role.Id,
    label: role.RoleName,
  }));

  const fields = [
    {
      name: "customerIds",
      label: "Customers",
      type: "multiselect",
      options: customersOptions || '',
      gridColumn: "span 2", // Make it span across two grid columns
      fullWidth: true,
    },
    {
      name: "roleId",
      label: "Roles",
      type: "select",
      options: roleOptions,
      required: true,
      gridColumn: "span 2",
    },
  ];

  // Preset initial values for edit mode
  const initialValues = {
    id: props.data ? props.data.Id : "",
    groupId: props.data ? props.data.GroupId : groupId,
    roleId: props.data ? props.data.RoleId : "",
    customerIds: props.data ? [props.data.CustomerId] : [], // Preset customerIds for edit mode
    createdBy: userId,
    createdDate: new Date().toISOString(),
    updatedBy: userId,
    updatedDate: new Date().toISOString(),
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { roleId, customerIds } = values;
      // Fetch role details by roleId
      const roleResponse = await fetchJsonDynamic(
        "groupRolesById",
        "groupRole",
        { id: roleId },
        base_url
      );
      if (roleResponse?.results) {
        const selectedRole = JSON.parse(roleResponse.results)[0];

        // Check if the role is unique and has multiple customers selected
        if ((selectedRole?.UniqueRole === true || selectedRole?.UniqueRole === 1) && customerIds.length > 1) {
          props.onClose();
          Swal.fire({
            icon: "warning",
            title: "Unique Role Restriction",
            text: `Only one customer can be assigned to ${selectedRole?.RoleName} unique role.`,
          });
          setSubmitting(false);
          return;
        }
      }
      // Construct a single payload
      const mutationData = {
        groupId: parseInt(groupId),
        roleId: parseInt(roleId),
      };
  
      if (props.isEditing) {
        // For editing, use customerId (single value)
        mutationData.id = props.data.Id; // Include the ID for update operation
        mutationData.customerId = props.data.CustomerId;
      } else {
        // For creation, use customerIds (array)
        mutationData.customerIds = customerIds;
      }
  

      // Send a single mutation request with the payload
      const response = await executeAnyMutation(
        props.isEditing ? "updateCustomerGroup" : "createCustomerGroup",
        mutationData,
        props.isEditing ? "customerGroup" : "inputModel",
        false,
        base_url
      );

      if (response && response.results) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "CustomerGroup records created successfully.",
        });
      }
         // Handle error response
    else if (response?.error) {
      props.onClose(); // Close form

      const errorData = JSON.parse(response.error);

      if (errorData?.ExistingCustomers?.length > 0) {
        const customerNames = errorData.ExistingCustomers.map(c => `${c.FirstName} (Group: ${c.GroupName})`).join(", ");

        Swal.fire({
          icon: "warning",
          title: "Some Customers Already in a Group",
          html: `<p>The following customers are already assigned to a group:</p><b>${customerNames}</b>`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: errorData.Message || "An error occurred while processing your request.",
        });
      }
    }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  const handleFieldChangeInternal = async (setFieldValue, field, value, values) => {
    setFieldValue(field.name, value);

    if (field.name === "roleId") {
      try {
        // Fetch role details by selected role ID
        const roleResponse = await fetchJsonDynamic(
          "groupRolesById",
          "groupRole",
          { id: value },
          base_url
        );

        if (roleResponse?.results) {
          const selectedRole = JSON.parse(roleResponse.results)[0];

          if (selectedRole?.UniqueRole === true || selectedRole?.UniqueRole === 1) {
            // Enforce single customer selection for unique roles
            setFieldValue("customerIds", ""); // Reset customer selection
            fields.find(f => f.name === "customerIds").type = "select"; // Change to single select
          } else {
            fields.find(f => f.name === "customerIds").type = "multiselect"; // Allow multiple selections
          }
        }
      } catch (error) {
        console.error("Error fetching role details:", error);
      }
    }

  };

  if (loading) {
    return <div className="justify-content-center">Loading...</div>;
  }

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      onFieldChange={handleFieldChangeInternal}
      title={props.data ? "Edit Customer Group" : "Create Customer Group"}
      subtitle={props.data ? "Edit an existing CustomerGroup record" 
        : "Add customers to a group. Only active, approved customers with a loan limit greater than 1 and not in any group are available"}
    />
  );
};

export default GroupMembersForm;